import { Modal } from 'antd-mobile';
import type { ShuMeiSMCaptchaOptions, ShuMeiSMCaptchaResult } from './shumei';
import { createShuMeiCaptchaPromise } from './shumei';

export function createShuMeiCaptchaModalPromise(
  options?: Partial<ShuMeiSMCaptchaOptions>,
): Promise<ShuMeiSMCaptchaResult> {
  const _elKey = 'shumei_sdk_secondary_verification_modal_container';
  return new Promise((resolve, reject) => {
    const { close } = Modal.show({
      className: 'shumei-captcha-modal-container',
      title: '请完成安全验证',
      content: <div id={_elKey} style={{ minHeight: '169px', overflow: 'hidden' }}></div>,
      destroyOnClose: true,
      closeOnMaskClick: true,
      showCloseButton: false,
      afterClose: () => {
        resolve({ rid: '', pass: false, close: true });
      },
    });
    createShuMeiCaptchaPromise({
      ...options,
      appendTo: _elKey,
      product: 'embed',
      width: '100%',
    })
      .then((r) => {
        resolve(r);
        close();
      })
      .catch((e) => {
        reject(e);
        close();
      });
  });
}
